<template>
    <div>
        <v-card class="mx-auto normal-card">
            <div class="data-table-section prev-test-tb cat-44">
                <v-data-table
                    :headers="headers"
                    fixed-header
                    :items="items"
                    hide-default-header
                    hide-default-footer
                    class="elevation-2 cust-table"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <TableHeader
                            :headers="headers"
                            :onSortChange="onSortChange"
                            :onHeaderAction="onHeaderAction"
                            :orderBy="orderBy"
                        />
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.name">
                                <td
                                    class="text-center rescheduletest"
                                    @click="gotoPastTest(item)"
                                >{{item.test_name}}</td>
                                <td class="duration-display">{{item.duration}}</td>
                                <td class="duration-display">{{item.test_type}}</td>
                                <td class="duration-display">{{item.test_subtype}}</td>
                                <td class="text-center">{{item.target_name}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <div class="btm-test-prev-test">Click on a test name to revisit that test</div>
            </div>
        </v-card>
        <div class="footer-btn">
            <div class="pull-left"></div>
            <div class="pull-right">
                <Pagination
                    :currentPage="currentPage"
                    :totalPage="totalPages"
                    :onPageChange="onPageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
    name: "Notification",
    mounted() {
        this.defaultData();
    },
    data() {
        return {
            headers: [
                {
                    text: "Test Name",
                    value: "test_name"
                },
                {
                    text: "Duration\n(Min)",
                    value: "duration",
                    class: "text-center",
                    hideSort: true
                },
                {
                    text: "Target Exam",
                    value: "target_exam",
                    class: "text-center",
                    hideSort: true
                }
            ],
            items: [],
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            orderBy: {
                field: "started",
                order: "DESC"
            },
            selectedExamTypes: []
        };
    },
    methods: {
        ...mapActions({
            getTestTarget: "utilStore/getTestTarget",
            getPastTestList: "testStore/getPastTestList"
        }),
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if(crd) {
                this.currentPage = crd.tabDetails[crd.selectedTab].page;
                this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
                this.selectedExamTypes = crd.tabDetails[crd.selectedTab].examTypes;
            }
            this.reqGetTestTargets();
            this.requestGetTestList();
        },
        getFormatedDate(date) {
            return moment(date).format("DD/MM/YYYY");
        },
        getFormatedTime(date) {
            return moment(date).format("hh:mm A");
        },
        reqGetTestTargets() {
            this.getTestTarget({})
                .then(response => {
                    // this.loading = false;
                    this.headers[2].options = response.map(x => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        c.checked = this.selectedExamTypes.includes(x.id);
                        return c;
                    });
                })
                .catch(err => {
                    this.$toasted.error('Error getting exam types');
                    this.loading = false;
                });
        },
        gotoPastTest(item) {
            let test_institute_id = item.test_institute_id;
            this.$router.push({
                name: "premium-test",
                params: {
                    test_id: item.id,
                    student_test_id: item.student_test_id,
                    test_institute_id
                }
            });
        },
        requestGetTestList() {
            let reqData = {
                type: "INSTITUTE",
                // test_types: [this.TEST_TYPE.PAST_TEST],
                target_ids: this.selectedExamTypes,
                orderBy: this.orderBy,
                test_name: null,
                pagination: { page: this.currentPage, pageSize: this.pageSize }
            };
            this.$root.showLoader = true;
            this.getPastTestList(reqData)
                .then(response => {
                    if(response.list.length == 0 && this.currentPage != 1 && !this.$route.query.resetPage) {
                        this.onPageChange(1);
                        return;
                    } 
                    this.$root.showLoader = false;
                    this.items = response.list;
                    this.totalPages = response.pagination.pageCount;
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requestGetTestList();
        },
        onSortChange() {
            this.requestGetTestList();
        },
        onHeaderAction(e) {
            if (e.data && e.data.selectedItems) {
                this.selectedExamTypes = e.data.selectedItems;
                let routeName = this.$route.name;
                let crd = this.getCurrentRouteDetails(routeName);
                crd.tabDetails[crd.selectedTab].examTypes = e.data.selectedItems;
                this.setRouteDetails(crd);
                this.onPageChange(1);
            }
        }
    }
};
</script>